<template>
  <div class="devices" v-loading="loading">
    <div
      class="item pointer"
      v-for="(item, index) in lists"
      :key="index"
      @click="toDeviceDetail(item)"
    >
      <img v-img="item.imgsrc" v-if="item.imgsrc" class="item-img" />
      <div class="item-desc">
        <div class="item-name ellipsis">
          {{ item.devicename }}
        </div>
        <div class="item-priceLine ellipsis">
          <span class="price">
            <span v-if="!item.preferentialPrice || item.face">面议</span>
            <template v-else>
              <span>￥{{ item.preferentialPrice }}</span>
              <span>/{{ unitMap[+item.unit] }}</span>
            </template>
          </span>
          <span class="throuth" v-if="item.discount !== '10' && !item.face">
            <span> ￥{{ item.minPrince }}</span>
            <span>/{{ unitMap[+item.unit] }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mallList } from "@/api/mall";
import { SERVICE_UNIT_TYPE } from "@/constant/dict";
export default {
  props: {
    cateId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      lists: [],
      lastItem: {},
      loading: false,
      unitMap: {},
    };
  },
  created() {
    this.getDicts();
    this.getDevicesList();
  },
  methods: {
    async getDevicesList() {
      this.loading = true;
      const { list } = await this.$axios
        .post(mallList, {
          ...this.page,
          serviceCategorySuperId: this.cateId,
        })
        .finally(() => {
          this.loading = false;
        });
      this.lists = list;
    },
    toDeviceDetail(data) {
      this.$router.push({ name: "deviceDetail", query: { id: data.id } });
    },
    moreClick() {
      this.$router.push({
        name: "mallStrict",
        query: { cateId: this.cateId },
      });
    },
    async getDicts() {
      const units = await this.$store.dispatch(
        "getDictData",
        SERVICE_UNIT_TYPE
      );
      const unitMap = {};
      units.forEach((item) => {
        unitMap[item.dictValue] = item.dictLabel;
      });
      this.unitMap = unitMap;
    },
  },
};
</script>
<style lang="scss" scoped>
.devices {
  min-height: 484px;
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 11.25px));
  gap: 15px;
}
.item {
  background: white;
  padding: 10px;
  &.isBottom {
    margin-bottom: 0;
  }
  &-img {
    height: 155px;
    width: 100%;
    object-fit: cover;
    margin-bottom: 12px;
    background: #e7e7e7;
  }
  &-name {
    text-align: center;
    font-size: 16px;
    color: #202020;
    width: 100%;
    margin-bottom: 6px;
    padding: 0 15px;
  }
  &-priceLine {
    font-size: 16px;
    text-align: center;
    width: 100%;
    span {
      &.price {
        font-weight: bold;
        color: #e67009;
        margin-right: 10px;
      }
      &.throuth {
        color: #9e9e9e;
        font-size: 13px;
        text-decoration: line-through;
      }
    }
  }
}
</style>
